import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import { isInteger, isBoolean, isNull, isObject } from 'iotera-base/object';
import settingIcon from '../../../../lib/components/icons/setting.svg';
import inputIcon from '../../../../lib/components/icons/input.svg';
import commandIcon from '../../../../lib/components/icons/command.svg';
import dataIcon from '../../../../lib/components/icons/data.svg';
import { SizeMe } from 'react-sizeme';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Routes */
import { domainIsTenant as dit } from '../../../../routes/routes'

/* Json */
import { safeDeepGet, stringify } from 'iotera-base/json'

/* Redux */
import { connect } from 'react-redux';

/* Sagas Actions */
import { buildWBoundActions, buildWSelector } from '../../../../redux/ducks'

import { getWidthColumnByPercent } from '../../../../lib/components/function';
import { TablePaginationActionsWrapped, CustomTableCell } from '../../../../custom/table';
import { WEBSERVICE_FETCH } from '../../../../lib/components/Preference';
import { SubViewHeader } from '../../../../lib/components/subHeader';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../../lib/components/callbackGlobal';

const WKEY = 'DEVICE_DATA';
const DEVICE_DATA = 'FETCH_DATA';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function formatConfig(config) {
  if (isNull(config)) {
    return '-';
  }
  if (config === 'config') {
    config = settingIcon;
  } else if (config === 'command') {
    config = commandIcon;
  } else if (config === 'data') {
    config = dataIcon;
  } else {
    config = inputIcon;
  }
  return config;
}

function formatValue(input) {
  if (isBoolean(input)) {
    return input ? 'true' : 'false';
  } else if (isObject(input)) {
    return stringify(input)
  }
  return input;
}

class DeviceData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navMini: false,
      loading: true,
      page: 0,
      rowsPerPage: 25
    };
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ page: 0, rowsPerPage });
  };

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const deviceId = safeDeepGet(_props, ['match', 'params', 'id']);
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wSetConfig({
      background_config: {
        [DEVICE_DATA]: {
          wparam: {
            ...domainIsTenant,
            type: WEBSERVICE_FETCH,
            path: '/fetch/web/device/data/' + deviceId,
          },
          wcallback: {
            finished: function (id, result) {
              // TODO Loading
              _this.setState({
                loading: false,
              })
            },
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    const deviceId = safeDeepGet(_props, ['match', 'params', 'id']);
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const DEVICE_DATA_RPAYLOAD = DEVICE_DATA + '_rpayload'
    const data = safeDeepGet(_props, ['items', DEVICE_DATA_RPAYLOAD, 'data'], []);
    const title = safeDeepGet(_props, ['items', DEVICE_DATA_RPAYLOAD, 'device_label'], 'Data Perangkat');
    const subTitle = safeDeepGet(_props, ['items', DEVICE_DATA_RPAYLOAD, 'device_id'], '');
    const { rowsPerPage, page } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let { loading } = _state;
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title={title} subTitle={subTitle} />
          <div className="view-content-dashboard">
            <Card>
              <SizeMe>{({ size }) =>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table">
                      <TableHead style={{ height: 0 }}>
                        <TableRow>
                          <CustomTableCell style={{
                            minWidth: getWidthColumnByPercent(25, size.width - 140),
                            maxWidth: getWidthColumnByPercent(25, size.width - 140)
                          }}>Waktu Update</CustomTableCell>
                          <CustomTableCell style={{
                            minWidth: getWidthColumnByPercent(25, size.width - 140),
                            maxWidth: getWidthColumnByPercent(25, size.width - 140)
                          }}>Konfigurasi</CustomTableCell>
                          <CustomTableCell style={{
                            minWidth: getWidthColumnByPercent(50, size.width - 140),
                            maxWidth: getWidthColumnByPercent(50, size.width - 140)
                          }}>Nilai</CustomTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, i) =>
                          <TableRow key={i} className='table-row-child-iotera'>
                            {/* old */}
                            <TableCell>
                              <div style={{ fontWeight: 500 }}>{item.time}</div>
                            </TableCell>
                            <TableCell>
                              <div className='row' style={{ padding: '0 10.5px' }}>
                                <div className='col-sm-1 centeringItem' style={{ padding: 0 }}>
                                  <img src={formatConfig(item.config)} style={{ height: 16, width: 16 }} alt="Icon" />
                                </div>
                                <div className='col-sm-11'>
                                  <div style={{ fontWeight: 900 }}>{item.sensor}</div>
                                  <div style={{ fontWeight: 500 }}>{item.param}</div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell>
                              {formatValue(item.value)}
                            </TableCell>
                          </TableRow>)}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
                            labelRowsPerPage='Baris terlihat:'
                            rowsPerPageOptions={[25, 50, 100]}
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              native: true,
                            }}
                            onPageChange={_this.handleChangePage}
                            onChangeRowsPerPage={_this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActionsWrapped}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </div>
                </CardBody>
              }</SizeMe>
            </Card>
          </div>
        </div >
      </Loader>
    );
  }
}

const mapStateToProps = function (state, ownProps) {
  return {
    items: wSelector.getMappedState(state)
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeviceData));